import { apiSlice } from "./apiSlice";

/**
 * Replace one costing header inside a list-page payload draft.
 *
 * @param {Object} draft Cached `{results: []}` list body.
 * @param {Object} costing Saved header with id, ranges, and warehouses.
 * @return {void}
 */
export function applyCostingToListDraft(draft, costing) {
  const rows = draft?.results;
  if (!Array.isArray(rows) || costing?.id == null) return;
  const index = rows.findIndex(row => Number(row.id) === Number(costing.id));
  if (index === -1) return;
  rows[index] = { ...rows[index], ...costing };
}

/**
 * Copy a saved costing header into every cached Facility Costing list page.
 *
 * The form already shows the PUT body. The list query can keep the old
 * nested warehouse and price until refetch finishes, so patch the rows
 * the table already has.
 *
 * @param {Function} dispatch
 * @param {Function} getState
 * @param {Object} costing Saved header with id, ranges, and warehouses.
 * @return {void}
 */
export function patchWarehouseCostingListCaches(dispatch, getState, costing) {
  if (costing?.id == null) return;
  const queries = getState()?.[apiSlice.reducerPath]?.queries || {};
  Object.values(queries).forEach(entry => {
    if (entry?.endpointName !== "getWarehouseCosting") return;
    dispatch(
      apiSlice.util.updateQueryData("getWarehouseCosting", entry.originalArgs, draft => {
        applyCostingToListDraft(draft, costing);
      }),
    );
  });
}
